import { Component, OnInit } from '@angular/core';
import { TopCourseService } from './top-course.service';
import { Router } from '@angular/router';
import { CourseData } from './top-course-mock';
import { CourData } from './top-course-data';
import { AdService } from '../../core/services/ad.service';
import { IMAGE_BASE__URL } from '../../core/services/CusHttp';


@Component( {
  selector: 'top-course',
  templateUrl: './top-course.component.html',
  styleUrls: [ './top-course.component.scss' ],
  providers: [ TopCourseService ]
} )
export class TopCourseComponent implements OnInit {
  IMAGE_BASE__URL = IMAGE_BASE__URL;
  courseData: any = [];   //课程数据
  adData: any = {}; //广告
  topClassify: any = []; //分类数据
  sort: number = 1;   //课程类型
  constructor(
    private _router: Router,
    private _service: TopCourseService,
    private _adService: AdService
  ) { }

  ngOnInit() {
    //获取广告图片
    this._adService.getAdInfo( 'course_ad' ).then( data => {
      this.adData = data[ 'data' ];
    } );

    //获取精品课程分类
    this._service.getTopClassify().then( data => {
      this.topClassify = data[ 'data' ];
      for ( let row of this.topClassify ) {
        if ( row[ 'type' ] === 1 ) {
          this.getFirstCourse();
        } else {
          //获取二级课程
          this._service.getCourse( row.direction_id, 1 ).then( res => {
            if ( res[ 'data' ] && res[ 'data' ].length > 0 ) {
              this.courseData = res[ 'data' ].slice( 0, 8 );
            }
          } );
        }
      }
    } );
  }

  //获取type==1的精品课程内容
  getFirstCourse() {
    this._service.getTopCourse().then( data => {
      if ( data[ 'data' ] && data[ 'data' ].length > 0 ) {
        this.courseData = data[ 'data' ].slice( 0, 8 );
      }
    } );
  }



  //标签切换改变
  handleChange( e: any ) {
    let index = e.index;
    this.courseData = [];
    if ( this.topClassify[ index ][ 'type' ] == 1 ) {
      this.getFirstCourse();
    } else {
      //获取二级课程
      this._service.getCourse( this.topClassify[ index ].direction_id, 1 ).then( data => {
        if ( data[ 'data' ] && data[ 'data' ].length > 0 ) {
          this.courseData = data[ 'data' ].slice( 0, 8 );
        }
      } );
    }

  }

  gotostation() {
    this._router.navigate( [ '/station' ] );
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/top-course/top-course.component.ts